/** Generate a UUID v4. Falls back to timestamp+random when crypto.randomUUID is unavailable. */
export function uuidv4(): string {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  } catch {
    // ignore
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
